import React from "react"
import { Link } from "gatsby"
import { WorkTags } from "../../components"

export default function WorkTile({ data }) {
  const title = data.title
  const link = data.slug

  const imageSrc = data.workFields?.tileImage
  const shortDesc = data.workFields?.shortDescription
  const tags = data.tags

  return (
    <Link
      to={`/work/${link}`}
      className="group flex flex-col h-full relative border-[4px] border-black rounded-none shadow-[5px_5px_0px_0px_rgba(0,0,0,1)] hover:shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] hover:translate-x-[-3px] hover:translate-y-[-3px] transition-all duration-150"
    >
      {imageSrc && (
        <div className="overflow-hidden">
          <img className="w-full" src={imageSrc} alt={title} />
        </div>
      )}
      <div className="p-4 bg-sky-300 flex flex-col flex-grow">
        <h4 className="text-black font-bold text-xl border-0">{title}</h4>
        {shortDesc && <p className="text-sm text-slate-800 mt-1">{shortDesc}</p>}
        <div className="mt-auto pt-3">
          <WorkTags data={tags} />
        </div>
      </div>
    </Link>
  )
}
